<template>
  <div class="apaas-preview" v-if="visible" ref="apaasPreview" @click="close">

    <div class="apaas-preview-container">
      <div class="apaas-preview-header" @click.stop>
        <div class="apaas-preview-header-utils">
          <div v-if="isMobile" @click="onClickShowUtilsOnMobil">
            <svg viewBox="0 0 16 16" width="16" height="16" fill="#FFFFFF">
              <circle cx="8" cy="3" r="1.5"></circle>
              <circle cx="8" cy="13" r="1.5"></circle>
              <circle cx="8" cy="8" r="1.5"></circle>
            </svg>
          </div>
          <div class="change-size" v-if="fileList[ownerIndex].fileType === 'img'">
            <div @click="onClickZoomOut">
              <svg viewBox="0 0 15 15" width="16" height="16" fill="#FFFFFF" opacity="1">
                <path d="M10.5 6.8h-6c-.4 0-.8.3-.8.8s.3.8.8.8h6c.4 0 .8-.3.8-.8s-.4-.8-.8-.8z"></path>
                <path
                  d="M7.5.2C3.5.2.3 3.5.3 7.4c0 4 3.3 7.2 7.2 7.2 4 0 7.2-3.3 7.2-7.2.1-3.9-3.2-7.2-7.2-7.2zm0 13c-3.2 0-5.8-2.6-5.8-5.8 0-3.2 2.6-5.8 5.8-5.8 3.2 0 5.8 2.6 5.8 5.8-.1 3.3-2.6 5.8-5.8 5.8z"></path>
              </svg>
            </div>
            <span class="apaas-preview-header-utils-pic-span">{{defaultScaler | formatFloat}}%</span>

            <div @click="onClickEnlarge">
              <svg viewBox="0 0 15 15" width="16" height="16" fill="#FFFFFF" opacity="1">
                <path
                  d="M7.5.2C3.5.2.3 3.5.3 7.4c0 4 3.3 7.2 7.2 7.2 4 0 7.2-3.3 7.2-7.2.1-3.9-3.2-7.2-7.2-7.2zm0 13c-3.2 0-5.8-2.6-5.8-5.8 0-3.2 2.6-5.8 5.8-5.8 3.2 0 5.8 2.6 5.8 5.8-.1 3.3-2.6 5.8-5.8 5.8z"></path>
                <path
                  d="M10.5 6.8H8.2V4.5c0-.4-.3-.8-.8-.8s-.6.4-.6.8v2.2H4.5c-.4 0-.8.3-.8.8s.3.8.8.8h2.2v2.2c0 .4.3.8.8.8s.8-.3.8-.8V8.2h2.2c.4 0 .8-.3.8-.8s-.4-.6-.8-.6z"></path>
              </svg>
            </div>
          </div>
          <div class="apaas-preview-header-utils-pic" v-if="fileList[ownerIndex].fileType === 'img'">

            <div @click="onClickRotate">
              <svg width="16" height="16" viewBox="0 0 16 16"
                   size="16" fill="#FFFFFF" version="1.1" xmlns="http://www.w3.org/2000/svg"
                   xmlns:xlink="http://www.w3.org/1999/xlink">
                <path
                  d="M12.3 2.19999C12.4 1.99999 12.3 1.89999 12.3 1.89999L9.89997 0.299988H9.79997C9.69997 0.299988 9.59997 0.399988 9.59997 0.499988V1.29999H8.99997C8.59997 1.29999 8.29997 1.69999 8.39997 2.09999C8.39997 2.49999 8.69997 2.79999 9.09997 2.79999H9.19997H9.59997V3.59999V3.69999C9.69997 3.79999 9.79997 3.89999 9.89997 3.79999L12.3 2.19999ZM4.89997 8.79999V12.2C4.89997 13.8 6.19997 15 7.69997 15H11.2C12.8 15 14 13.8 14 12.3V8.79999C14 7.19999 12.8 5.99999 11.2 5.99999H7.79997C6.19997 5.99999 4.99997 7.19999 4.89997 8.79999ZM6.49997 8.79999C6.49997 8.19999 6.99997 7.59999 7.69997 7.59999H11.2C11.8 7.59999 12.4 8.09999 12.4 8.79999V12.2C12.4 12.8 11.9 13.4 11.2 13.4H7.69997C7.09997 13.4 6.49997 12.9 6.49997 12.2V8.79999ZM2.69997 8.59999H2.49997C2.09997 8.39999 1.89997 7.99999 1.99997 7.59999C2.04997 7.39999 2.09997 7.22499 2.14997 7.04999C2.19997 6.87499 2.24997 6.69999 2.29997 6.49999C2.49997 6.09999 2.89997 5.89999 3.29997 6.09999C3.69997 6.29999 3.89997 6.69999 3.69997 7.09999L3.39997 7.99999C3.29997 8.29999 2.99997 8.59999 2.69997 8.59999ZM7.79997 2.29999C7.59997 1.89999 7.19997 1.69999 6.79997 1.89999C6.49997 1.99999 6.09997 2.19999 5.89997 2.39999C5.49997 2.59999 5.39997 2.99999 5.59997 3.39999C5.69997 3.69999 5.89997 3.79999 6.19997 3.79999C6.29997 3.79999 6.49997 3.79999 6.59997 3.69999C6.74997 3.64999 6.87497 3.57499 6.99997 3.49999C7.12497 3.42499 7.24997 3.34999 7.39997 3.29999C7.79997 3.09999 7.89997 2.69999 7.79997 2.29999ZM3.99997 5.89999C3.79997 5.89999 3.69997 5.89999 3.59997 5.79999C3.19997 5.39999 3.09997 4.89999 3.39997 4.59999C3.59997 4.29999 3.89997 3.99999 4.09997 3.79999C4.39997 3.49999 4.89997 3.49999 5.19997 3.79999C5.49997 4.09999 5.49997 4.59999 5.19997 4.89999C4.99997 5.09999 4.79997 5.29999 4.59997 5.59999C4.49997 5.79999 4.19997 5.89999 3.99997 5.89999Z"
                  fill="inherit" fill-rule="evenodd" clip-rule="evenodd"></path>
              </svg>
              <div>旋转</div>
            </div>
          </div>
          <div class="apaas-preview-header-utils-common" v-if="isShowUtilsOnMobile">
            <div @click="onClickCopyUrl">
              <svg width="16" height="16" viewBox="0 0 16 16"
                   size="16" fill="#FFFFFF" version="1.1" xmlns="http://www.w3.org/2000/svg"
                   xmlns:xlink="http://www.w3.org/1999/xlink">
                <path
                  d="M12.2426 3.75739C11.4615 2.97634 10.1952 2.97634 9.41414 3.75739L7.6476 5.52392C7.25708 5.91444 6.62392 5.91444 6.23339 5.52392C5.84287 5.13339 5.84287 4.50023 6.23339 4.1097L7.99992 2.34317C9.56202 0.781076 12.0947 0.781076 13.6568 2.34317C15.2189 3.90527 15.2189 6.43793 13.6568 8.00003L11.8902 9.76656C11.4997 10.1571 10.8666 10.1571 10.476 9.76656C10.0855 9.37603 10.0855 8.74287 10.476 8.35234L12.2426 6.58581C13.0236 5.80477 13.0236 4.53844 12.2426 3.75739ZM5.52252 6.23479C5.91304 6.62532 5.91304 7.25848 5.52252 7.64901L3.75723 9.41429C2.97619 10.1953 2.97619 11.4617 3.75723 12.2427C4.53828 13.0238 5.80461 13.0238 6.58566 12.2427L8.35094 10.4774C8.74147 10.0869 9.37463 10.0869 9.76516 10.4774C10.1557 10.868 10.1557 11.5011 9.76516 11.8916L7.99987 13.6569C6.43778 15.219 3.90512 15.219 2.34302 13.6569C0.780923 12.0948 0.780924 9.56217 2.34302 8.00007L4.1083 6.23479C4.49883 5.84427 5.13199 5.84427 5.52252 6.23479ZM10.8285 6.58581C11.219 6.19529 11.219 5.56212 10.8285 5.1716C10.4379 4.78107 9.80477 4.78107 9.41425 5.1716L5.17161 9.41424C4.78108 9.80476 4.78108 10.4379 5.17161 10.8285C5.56213 11.219 6.1953 11.219 6.58582 10.8285L10.8285 6.58581Z"
                  fill="inherit" fill-rule="evenodd" clip-rule="evenodd"></path>
              </svg>
              <div>复制附件URL</div>
            </div>
            <div @click="onClickDownload">
              <svg width="16" height="16" viewBox="0 0 16 16"
                   size="16" fill="#FFFFFF" version="1.1" xmlns="http://www.w3.org/2000/svg"
                   xmlns:xlink="http://www.w3.org/1999/xlink">
                <path
                  d="M7.99994 1C8.55222 1 8.99994 1.44772 8.99994 2V6H10.3354C11.0062 6 11.3792 6.77595 10.9601 7.29976L8.62463 10.2191C8.30437 10.6195 7.6955 10.6195 7.37524 10.2191L5.03974 7.29976C4.6207 6.77595 4.99363 6 5.66444 6H6.99994V2C6.99994 1.44772 7.44765 1 7.99994 1ZM3 12C2.44772 12 2 12.4477 2 13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13C14 12.4477 13.5523 12 13 12H3Z"
                  fill="inherit" fill-rule="evenodd" clip-rule="evenodd"></path>
              </svg>
              <div>下载</div>
            </div>
          </div>
        </div>
        <div class="apaas-preview-header-title">{{fileList[ownerIndex].title}}</div>
        <div class="apaas-preview-header-close" @click="close">
          <svg width="24" height="24" viewBox="0 0 24 24" size="16"
               fill="#FFFFFF" version="1.1" xmlns="http://www.w3.org/2000/svg"
               xmlns:xlink="http://www.w3.org/1999/xlink">
            <path
              d="M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z"
              fill="inherit" fill-rule="evenodd" clip-rule="evenodd"></path>
          </svg>
        </div>
      </div>

      <div class="apaas-preview-left-arrow" @click.stop>
                <span @click="onClickToLeft" v-if="ownerIndex !== 0 "><svg data-name="\u56FE\u5C42 1"
                                                                           viewBox="0 0 40 40"
                                                                           width="40" height="40"><path
                  d="M21 16l-4 4 4 4" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="2"></path></svg></span>
      </div>
      <div class="apaas-preview-right-arrow" @click.stop>
                <span @click="onClickToRight" v-if="ownerIndex < fileList.length-1 "><svg data-name="\u56FE\u5C42 1"
                                                                                          viewBox="0 0 40 40" width="40"
                                                                                          height="40"
                ><path
                  d="M19 16l4 4-4 4" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="2"></path></svg></span>
      </div>
      <div class="apaas-preview-wrapper" v-for="(item,tabIndex)  in fileList" :key="tabIndex">
        <div class="apaas-preview-wrapper-video" v-if="item.fileType === 'video' && ownerIndex === tabIndex">
          <ApaasVideoPreview :href="item.href"/>
        </div>
        <div v-if="item.fileType === 'img' && ownerIndex === tabIndex"
             class="apaas-preview-wrapper-image" @mousedown="moveImage" draggable="false">
          <ApaasImagePreview :href="item.href" ref="imgView" :styleOptions="styleOptions"
                             :isShowDrag="isShowDrag"/>
        </div>
      </div>
      <div class="apaas-preview-footer" @click.stop>
        <ul>
          <li v-for="(item,tabIndex) in fileList" :class="ownerIndex===tabIndex ? 'selected':''"
              @click="onClickSelectComponent(tabIndex)" :key="tabIndex">
            <div>
              <img v-if="item.fileType === 'img'" :src="item | footerImg" alt="image"/>
              <svg v-if="item.fileType === 'video'" class="icon" aria-hidden="true">
                <use xlink:href="#icon-mp"></use>
              </svg>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import ApaasVideoPreview from "./AtomVideoPreview.vue";
  import ApaasImagePreview from "./AtomImagePreview.vue";
  import {clone} from "../../../assets/js/Untis"

  export default {
    name: "AtomListPreview",
    components: {ApaasVideoPreview, ApaasImagePreview},
    props: {
      dataList: {
        type: Array,
        default: () => []
      },
      index: {
        type: Number,
        default: 0
      },
      visible: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        styleOptions: {
          imageStyle: {},
          wrapperStyle: {},
        },
        defaultScaler: 1,
        wrapperMove: {
          x: 0,
          y: 0
        },
        rotateDeg: 0,
        ownerIndex: 0,
        isMobile: false,
        isShowUtilsOnMobile: true,
        fileList: [],
      };
    },
    filters: {
      formatFloat: num => {
        return (num * 100).toFixed(0)
      },
      // 处理底部显示的小图
      footerImg: item => {
        let url = item.fileType === 'img' ? item.thumbnail : item.poster
        if (url.length === 0) {
          // 默认的图片地址
          url = ''
        }
        return url
      }
    },
    computed: {
      isShowDrag() {
        return this.defaultScaler > 1
      }
    },
    methods: {
      // 关闭方法
      close() {
        console.log('close')
        this.$emit('close')
      },
      // 复制链接到剪切板
      async onClickCopyUrl() {
        await navigator.clipboard.writeText(this.fileList[this.ownerIndex].href);
        if (!this.isMobile) {
          this.$message.success('复制成功')
        }
      },
      // 切换向左
      onClickToLeft() {
        if (this.ownerIndex > 0) {
          this.ownerIndex = this.ownerIndex - 1
        }
        this.imageChangeReset()
      },
      // 向右切换
      onClickToRight() {
        if (this.ownerIndex < this.fileList.length) {
          this.ownerIndex = (this.ownerIndex + 1) % this.fileList.length
        }
        this.imageChangeReset()
      },

      onClickEnlarge() {
        this.defaultScaler *= 1.5;
        if (this.defaultScaler > 5) {
          this.defaultScaler = 5;
        }
        this.wrapperMove = {
          x: 0,
          y: 0
        },
          this.update()

      },
      onClickZoomOut() {
        this.defaultScaler *= 0.66;
        if (this.defaultScaler < 0.1) {
          this.defaultScaler = 0.1;
        }
        this.wrapperMove = {
          x: 0,
          y: 0
        },
          this.update()
      },
      onClickRotate() {
        this.rotateDeg = (this.rotateDeg + 90) % 360
        this.wrapperMove = {
          x: 0,
          y: 0
        },

          this.update()

      },
      update() {
        this.$set(this.styleOptions, 'imageStyle', {
          transform: `rotate(${this.rotateDeg}deg) scale3d(${this.defaultScaler},${this.defaultScaler},1)`,
        })
        this.$set(this.styleOptions, 'wrapperStyle', {
          transform: `translate3d(${this.wrapperMove.x}px,${this.wrapperMove.y}px,0px)`
        })
      },
      // 鼠标拖动图片移动
      moveImage(e) {
        if (this.isShowDrag) {
          const currentPosX = e.clientX
          const currentPosY = e.clientY
          document.onmousemove = (e) => {
            const moveX = e.clientX
            const moveY = e.clientY

            const wrapper = document.querySelector('#apaasPreviewImageWrapper')
            const image = document.querySelector('#apaasPreviewImage')
            const i2t = image.getBoundingClientRect().top
            const i2l = image.getBoundingClientRect().left
            const w2t = wrapper.getBoundingClientRect().top
            const w2l = wrapper.getBoundingClientRect().left
            const i2b = image.getBoundingClientRect().bottom
            const i2r = image.getBoundingClientRect().right
            const w2b = wrapper.getBoundingClientRect().bottom
            const w2r = wrapper.getBoundingClientRect().right


            // 左移
            if (currentPosX - moveX < i2r - w2r && currentPosX - moveX > 0) {
              this.wrapperMove.x += e.movementX
            }
            // 右移
            if (moveX - currentPosX < w2l - i2l && moveX - currentPosX > 0) {
              this.wrapperMove.x += e.movementX
            }
            // 上移
            if (currentPosY - moveY < i2b - w2b && currentPosY - moveY > 0) {
              this.wrapperMove.y += e.movementY
            }
            // 下移
            if (moveY - currentPosY < w2t - i2t && moveY - currentPosY > 0) {
              this.wrapperMove.y += e.movementY
            }
            this.update()


          }
          document.onmouseup = function () {
            e.preventDefault()
            document.onmousemove = null;
            document.onmouseup = null;
          };
        }

      },
      onClickSelectComponent(index) {
        this.ownerIndex = index
        this.imageChangeReset()
      },
      onClickDownload() {
        let form = document.createElement('form');
        form.innerHTML = '<form method="GET"></form>'
        form.setAttribute('action', this.fileList[this.ownerIndex].href);
        document.querySelector('body').appendChild(form)
        form.submit();
        document.body.removeChild(form)
      },
      onClickShowUtilsOnMobil() {
        if (this.isMobile) {
          this.isShowUtilsOnMobile = !this.isShowUtilsOnMobile
        }
      },
      checkMobile() {
        if (window.innerWidth < 700) {
          this.isMobile = true
          this.isShowUtilsOnMobile = false

          let startTime = '' // 触摸开始时间
          let startDistanceX = '' // 触摸开始X轴位置
          let startDistanceY = '' // 触摸开始Y轴位置
          let endTime = '' // 触摸结束时间
          let endDistanceX = '' // 触摸结束X轴位置
          let endDistanceY = '' // 触摸结束Y轴位置
          let moveTime = '' // 触摸时间
          let moveDistanceX = '' // 触摸移动X轴距离
          let moveDistanceY = '' // 触摸移动Y轴距离


          let dis1 = 0 // 触摸开始距离
          let dis2 = 0 // 触摸结束距离

          let touches = 0

          document.body.addEventListener('touchstart', (e) => {
            touches = e.touches.length
            if (touches === 1) {
              startTime = new Date().getTime()
              startDistanceX = e.changedTouches[0].clientX
              startDistanceY = e.changedTouches[0].clientY
            }
            if (touches === 2) {
              dis1 = Math.sqrt(Math.pow(e.changedTouches[0].clientX - e.changedTouches[1].clientX, 2) + Math.pow(e.changedTouches[0].clientY - e.changedTouches[1].clientY, 2))
            }
          })
          document.body.addEventListener('touchmove', e => {

            if (touches === 2) {
              dis2 = Math.sqrt(Math.pow(e.changedTouches[0].clientX - e.changedTouches[1].clientX, 2) + Math.pow(e.changedTouches[0].clientY - e.changedTouches[1].clientY, 2))
              let scale = dis2 / dis1
              if (scale > 1) {
                this.defaultScaler *= 1.1
              } else {
                this.defaultScaler *= 0.9
              }
              if (this.defaultScaler < 0.5) {
                this.defaultScaler = 0.5;
              }
              if (this.defaultScaler > 5) {
                this.defaultScaler = 5
              }
              this.update()
            }
            if (touches === 1) {
              this.wrapperMove.x = e.changedTouches[0].clientX - startDistanceX
              this.wrapperMove.y = e.changedTouches[0].clientY - startDistanceY
              this.update()
            }
          })
          // document.body.addEventListener('touchend', (e) => {
          //
          //   if (touches === 1 && this.defaultScaler <= 1) {
          //     endTime = new Date().getTime()
          //     endDistanceX = e.changedTouches[0].clientX
          //     endDistanceY = e.changedTouches[0].clientY
          //     moveTime = endTime - startTime
          //     moveDistanceX = startDistanceX - endDistanceX
          //     moveDistanceY = startDistanceY - endDistanceY
          //     // 判断滑动距离超过40 且 时间小于500毫秒
          //     if (this.defaultScaler <= 1) {
          //       if ((Math.abs(moveDistanceX) > 40 || Math.abs(moveDistanceY) > 40) && moveTime < 500) {
          //         // 判断X轴移动的距离是否大于Y轴移动的距离
          //         if (Math.abs(moveDistanceX) > Math.abs(moveDistanceY)) {
          //           // 左右
          //           moveDistanceX < 0 ? this.onClickToLeft() : this.onClickToRight()
          //         } else {
          //           // 上下
          //           // console.log(moveDistanceY > 0 ? '上' : '下')
          //         }
          //       }
          //     }
          //   }
          //   touches = 0
          // })
        } else {
          this.isMobile = false
          this.isShowUtilsOnMobile = true
        }
      },
      imageChangeReset() {
        this.wrapperMove = {
          x: 0,
          y: 0
        }
        this.rotateDeg = 0
        this.defaultScaler = 1
        this.update()
      },
      // 处理数据类型
      dealWithDataList() {
        let result = []
        let imgTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp']
        let videoTypes = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'mkv', 'mpg', 'mpeg', 'mpe', '3gp', '3g2']
        let temp = clone(this.dataList)
        for (let item of temp) {
          const fileType = item.fileType && item.fileType.includes('/') ? item.fileType.split('/').slice(-1)[0] : item.fileType
          if (imgTypes.includes(fileType)) {
            item.fileType = 'img'
            result.push(item)
          }
          if (videoTypes.includes(fileType)) {
            item.fileType = 'video'
            result.push(item)
          }
        }
        this.fileList = result
      },
      init() {
        window.onresize = () => {
          this.checkMobile()
        }

        const eleToBody = this.$el
        document.querySelector('body').appendChild(eleToBody)

      },
    },
    created() {
    },
    watch: {
      visible() {
        if (this.visible) {
          this.dealWithDataList()
          this.ownerIndex = this.index
         console.log('visible', this.fileList, this.ownerIndex, this.fileList[this.ownerIndex])
        }
      }
    },
    mounted() {
      this.ownerIndex = this.index
      this.checkMobile()
      this.init()
    },

  };
</script>

<style scoped lang="less">

  .apaas-preview {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9000;
    background: rgba(23, 24, 34, 0.9);

    &-header {
      display: flex;
      color: #ffffff;
      height: 64px;
      align-items: center;
      justify-content: space-between;
      padding: 24px 40px;
      box-sizing: border-box;
      background: rgba(0, 0, 0, 0.9);
      position: relative;
      z-index: 10;
      position: relative;

      &-title {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }

      &-utils {
        display: flex;
        align-items: center;

        .icon-public {
          display: flex;

          div {
            position: relative;
            margin-right: 24px;

            &:hover {
              div {
                height: 30px;
                overflow: visible;
              }
            }

            svg {
              cursor: pointer;
            }

            div {
              position: absolute;
              height: 0;
              display: block;
              overflow: hidden;
              transition: height 0.2s;
              background: #636363;
              padding: 0 8px;
              font-size: 12px;
              white-space: nowrap;
              line-height: 30px;
              border-radius: 4px;
              top: 120%;
              left: 50%;
              transform: translate(-50%, 0);


              &:before {
                content: ' ';
                height: 0;
                width: 0;

                border: 6px solid transparent;
                border-bottom: 6px solid #636363;
                position: absolute;
                top: -12px;
                left: 50%;
                transform: translate(-50%, 0);
                overflow: hidden;
              }
            }
          }
        }

        &-pic {
          margin-right: 24px;
          border-right: 1px solid #ffffff;
          display: flex;
          .icon-public();

          &-span {
            margin-right: 24px;
            width: 40px;
            text-align: center;
          }
        }

        &-common {
          .icon-public();
        }
      }

      &-close {
        cursor: pointer;
        background: #636363;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
          width: 16px;
          height: 16px;
        }

        &:hover {
          background: #e56833;
        }
      }
    }

    &-container {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }


    .change-size {
      position: fixed;
      top: 84px;
      display: flex;
      left: 20px;

      >:first-child {
        margin-right: 20px;
      }
    }
  }

  .apaas-preview-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;

    &-video {
      display: block;
      width: 70%;
      height: 70vh;
    }

    &-image {
      width: 70%;
      height: 70vh;
      overflow: hidden;
    }
  }

  .arrow {
    position: absolute;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    z-index: 2;


    span {
      color: #ffffff;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background: #636363;

      &:hover {
        background: #e56833;
        cursor: pointer;
      }
    }

  }

  .apaas-preview-left-arrow {
    .arrow();
    left: 0;
    margin-left: 20px;
  }

  .apaas-preview-right-arrow {
    .arrow();
    right: 0;
    margin-right: 20px;
  }

  .apaas-preview-footer {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;

    ul {
      display: flex;

      .selected {
        border-radius: 2px;
        box-shadow: 0 0 0 2px #ffffff;
      }

      li {
        color: #ffffff;
        cursor: pointer;
        margin-left: 16px;
        height: 40px;
        width: 40px;
        opacity: 1;
        display: flex;
        align-items: center;
        justify-content: center;

        >div{
          width: 100%;
          height: 100%;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .icon {
            width: 100%;
            height: 100%;
            vertical-align: -0.15em;
            fill: currentColor;
            overflow: hidden;
            margin-right: 10px;
          }
        }

      }
    }
  }

  @media only screen and (max-width: 700px) {
    .apaas-preview-wrapper {
      &-video {
        width: 100%;
      }

      &-image {
        width: 100%;
      }
    }

    .apaas-preview {
      &-header {
        background: #e56833;
        height: 44px;

        &-close {
          background: #e56833;
          position: absolute;
          left: 10px;
        }

        &-utils {
          position: absolute;
          right: 10px;

          &-pic {
            margin: 0;
            border: none;
            position: absolute;
            top: 60px;
            right: 10px;
            width: 32px;
            height: 32px;
            border-radius: 50%;
            background: #636363;
            display: flex;
            align-items: center;
            justify-content: center;
            user-select: none;

            div {
              margin: 0;

              div {
                display: none;
              }
            }
          }

          &-common {
            position: absolute;
            display: flex;
            flex-direction: column;
            width: 140px;
            top: 30px;
            right: -6px;
            background: #1f2d3d;
            padding: 8px 20px;
            box-sizing: content-box;
            border-radius: 4px;

            &:before {
              content: ' ';
              height: 0;
              width: 0;

              border: 6px solid transparent;
              border-bottom: 6px solid #1f2d3d;
              position: absolute;
              top: -12px;
              right: 8px;
              overflow: hidden;
            }

            div {
              display: flex;
              position: static;
              overflow: visible;
              margin: 0;
              padding: 0;
              align-items: center;
              font-size: 14px;
              width: 140px;

              div {
                overflow: visible;
                position: static;
                display: block;
                height: 30px;
                background: transparent;
                transform: translate(0, 0);

                &:before {
                  content: none;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
